// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"172":"6f3140a1","212":"b749463e","371":"6f3140a1"}[chunkId] + ".chunk.css";
};